import { GET_LIST, useQuery } from "react-admin";

export const useOfficeSurfaces = officeId => useQuery({
  type: GET_LIST,
  resource: 'arenaoffices',
  payload: {
    filter: { effectiveOffices: officeId, _scope: 'Tenant' },
    pagination: { page: 1, perPage: 9999 }
  }
}, {
  enabled: officeId != null,
})
